/* eslint-disable import/prefer-default-export */
import BaseFeature from '@appblocks/codegeneration/BaseFeature';
import ProjectConfiguration from '@appblocks/codegeneration/ProjectConfiguration';
import {
    CodeBlock,
    BlockType,
    SettingType,
    Define,
    ValidationMessageType,
    ValidationMessage,
    SettingState,
    Setting,
    TibboDataType,
} from '@appblocks/codegeneration/types';


export const getCodeBlocks = (feature: BaseFeature): CodeBlock[] => {
    const blocks: CodeBlock[] = [];

    const NAME = feature.getSettingValue('NAME');
    const DUTY = feature.getSettingValue('DUTY');
    const FREQUENCY = feature.getSettingValue('FREQUENCY');
    const PIN = feature.getSettingValue('PIN');
    if (!PIN) {
        return blocks;
    }
    const dtsName = `${NAME.toLowerCase()}_pwm`;

    blocks.push({
        location: 'VARIABLE_DECLARATIONS',
        blockType: BlockType.CODE,
        template: `
${dtsName} = machine.PWM(machine.Pin(${PIN}), freq=${FREQUENCY}, duty_u16=int(${DUTY} / 100 * 65535))`,
    });

    blocks.push({
        location: `var_${DUTY}_set`,
        blockType: BlockType.CODE,
        template: `
${dtsName}.duty_u16(int(${DUTY} / 100 * 65535))
`,
    });

    blocks.push({
        location: `var_${FREQUENCY}_set`,
        blockType: BlockType.CODE,
        template: `
${dtsName}.freq(${FREQUENCY})
`,
    });


    return blocks;
};
